var $4ab371254445a3f4$exports = {};
$4ab371254445a3f4$exports = {
    "pending": `\xeen a\u{219}teptare`
};


export {$4ab371254445a3f4$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
